export const EyeWatch = (e: MouseEvent) => {

    const eye = document.querySelector('.eye-opened') as HTMLElement
    if (eye) {
        const x = (eye.getBoundingClientRect().left) + (eye.getBoundingClientRect().width / 2);
        const y = (eye.getBoundingClientRect().top) + (eye.getBoundingClientRect().height / 2);
        const rad = Math.atan2(e.pageX - x, e.pageY - y);
        const rot = (rad * (180 / Math.PI) * -1) + 200;
        eye.style['transform'] = `translate(-50%, -50%) rotate(${rot}deg)`
    }
}